import CalculatorsController from '../../src/javascripts/cvm';
import ProvationRoi from '../../src/javascripts/models/provation/roi';
import MarketoHelper from '../../src/javascripts/helpers/application/marketo_helper';
import '../../src/javascripts/helpers/application/radio_button_div_toggler';
import '../../src/stylesheets/provation/roi.scss';

(function() {
  $(() => CalculatorsController.run(new ProvationRoi()));
}).call(this);

$(() => {
  const marketo_helper = new MarketoHelper();
  marketo_helper.run();
});
